// extracted by mini-css-extract-plugin
export default {"editValuePopover":"editValuePopover___ttcp_","title":"title___lPpxf","footer":"footer___ceE1O"};